import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getLocalidadesOperarios`, method: 'GET', body: null, token: token})
}